function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgWorldMap = function SvgWorldMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052AC"
    },
    d: "M5.39,438.444c-2.964,0-5.39-2.424-5.39-5.389V78.944c0-2.964,2.425-5.389,5.39-5.389H506.61 c2.964,0,5.39,2.424,5.39,5.389v354.112c0,2.964-2.425,5.389-5.39,5.389H5.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ABEBFF"
    },
    d: "M487.62,410.769c0,1.778-1.457,3.234-3.235,3.234H27.614c-1.778,0-3.234-1.456-3.234-3.234V101.231 c0-1.778,1.456-3.234,3.234-3.234h456.773c1.778,0,3.235,1.456,3.235,3.234v309.538H487.62z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.43,
    y: 98.001,
    style: {
      fill: "#76D8FF"
    },
    width: 153.151,
    height: 316.008
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M47.966,410.769V101.231c0-1.778,1.454-3.234,3.234-3.234H27.614 c-1.778,0-3.234,1.456-3.234,3.234v309.539c0,1.778,1.456,3.234,3.234,3.234H51.2C49.421,414.003,47.966,412.548,47.966,410.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052AC"
    },
    d: "M106.172,354.12h-21.59v-21.59c0-4.329-3.508-7.837-7.837-7.837c-4.328,0-7.837,3.508-7.837,7.837 v21.59H47.32c-4.329,0-7.837,3.508-7.837,7.837s3.508,7.837,7.837,7.837h21.589v21.59c0,4.329,3.509,7.837,7.837,7.837 c4.329,0,7.837-3.508,7.837-7.837v-21.59h21.59c4.329,0,7.837-3.508,7.837-7.837S110.501,354.12,106.172,354.12z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0079F1"
    },
    cx: 76.748,
    cy: 361.953,
    r: 19.061
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M140.631,294.261c0,0-13.437,12.445,5.169,29.56c18.605,17.113-4.653,33.707,10.853,56.526 c15.504,22.82-4.137-6.222,24.29-35.781c28.424-29.56,10.336-36.822-5.685-44.082C159.237,293.223,153.035,279.74,140.631,294.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35D34F"
    },
    d: "M115.823,264.699c0,0,2.068-6.741,12.92-1.554c10.854,5.186,12.92-22.3,32.559-29.559 c19.641-7.261,20.158-16.078,7.754-22.82c-12.403-6.741-8.787-11.928-20.673,4.668c-11.888,16.596-19.862-15.002-1.551-20.744 c8.27-2.592,10.336-14.52,0-18.151c-10.337-3.631-32.041,1.035-42.896-11.409c-10.853-12.445-28.424-24.892-43.93,1.556 c-15.504,26.449-6.203,25.928,0,28.523c6.203,2.593,13.436-4.148,20.671,9.335c7.237,13.483-2.067,38.895,7.237,48.228 c9.302,9.335-0.678,28.12,35.662,32.673c4.133,0.518,8.267,1.557,10.335,3.631c2.067,2.073,9.82-9.854-6.719-13.482 C110.656,271.96,113.756,267.811,115.823,264.699z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M173.62,166.313c4.904,3.28,14.472,1.555,9.818,12.446c-4.649,10.892-6.2,28.523,3.102,34.747 c9.303,6.222,8.27-19.19,25.325-19.19c17.054,0,28.424-60.675-7.753-50.303C167.936,154.386,168.969,163.202,173.62,166.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M452.792,151.646c5.685-11.409-14.988-8.817-26.874-1.555c-11.889,7.261-25.842,6.222-33.593,1.555 c-7.754-4.668-4.137,7.26-16.021,8.818c-11.889,1.555-25.326,2.592-22.741-7.262c2.584-9.852-10.854-5.187-10.854-5.187 c-11.372,3.632-19.639,16.596-17.055,28.005c2.585,11.411-14.988,18.151-31.01,11.411c-16.02-6.742-35.144,1.035-40.829,21.262 c-5.683,20.224-9.818,24.374-17.053,31.634c-7.236,7.26,9.302,16.595,20.154-0.518c10.855-17.114,18.091-3.631,24.808,3.63 c2.819,3.047,6.72,10.373,6.72,10.373s1.146,2.55,3.144,6.11c-2.011-0.653-4.15-1.017-6.377-1.017h-2.551 c-3.692-4.138-9.051-6.743-15.021-6.743h-22.74c-11.131,0-20.156,9.056-20.156,20.226c0,11.17,9.025,20.224,20.156,20.224h16.944 c0.178,0.223,0.36,0.44,0.544,0.653c-1.006,3.375-2.687,12.016,4.523,16.84c9.094,6.083-5.052,9.633,3.537,24.84 c8.588,15.212,17.178,11.661,22.23,3.548c5.052-8.111,3.03-10.138,9.599-15.207c6.567-5.071,7.576-13.689,1.01-20.786 c-2.863-3.095-2.846-6.767-1.914-9.927c1.616-2.032,2.861-4.375,3.629-6.926c0.191-0.247,0.305-0.385,0.305-0.385l-0.205,0.033 c0.505-1.798,0.784-3.692,0.784-5.652c0-0.568-0.041-1.125-0.086-1.682c2.675,2.071,5.533,3.522,8.484,3.852 c13.059,1.458,9.374-11.166,18.166-11.091c5.053,2.31,7.882,6.192,9.745,14.204c3.616,15.557,5.683,2.592,16.02-7.78 c10.337-10.372,13.438-1.712,27.908,11.41c14.471,13.12,8.787-5.187,7.237-14.52c-1.551-9.337,18.608-0.106,12.92-21.235 c-5.686-21.132,11.371-4.175,14.988-20.77c3.618-16.596-11.887-19.188-7.236-32.155c4.652-12.964,17.667-20.405,20.156-2.074 c2.73,20.101,22.642,17.545,17.991-2.162c-4.652-19.705-1.283-19.605,6.467-24.792C466.397,165.66,447.107,163.056,452.792,151.646 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35D34F"
    },
    d: "M400.076,336.786c-11.22,2.679-7.235,21.827,6.203,20.248c13.435-1.579,22.224-0.542,27.908,11.905 c5.685,12.447,25.324-14.521,14.987-28.003c-10.336-13.485-8.267-14.521-13.436-23.337 C430.568,308.781,410.929,334.192,400.076,336.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M424.151,288.629h-1.077c-4.328,0-7.837-3.508-7.837-7.837c0-4.329,3.509-7.837,7.837-7.837h1.077 c4.329,0,7.837,3.508,7.837,7.837C431.988,285.12,428.479,288.629,424.151,288.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35D34F"
    },
    d: "M381.576,323.124c-2.068,0-4.086-0.837-5.548-2.299c-1.453-1.463-2.288-3.479-2.288-5.538 c0-2.069,0.836-4.086,2.288-5.549c1.462-1.452,3.479-2.287,5.548-2.287c2.058,0,4.075,0.836,5.538,2.287 c1.463,1.463,2.299,3.479,2.299,5.549c0,2.058-0.836,4.074-2.299,5.538C385.651,322.288,383.633,323.124,381.576,323.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M140.664,154.969c-2.059,0-4.075-0.836-5.539-2.299c-1.462-1.452-2.298-3.468-2.298-5.538 c0-2.069,0.836-4.086,2.298-5.538c1.453-1.463,3.48-2.299,5.539-2.299c2.058,0,4.086,0.836,5.538,2.299 c1.462,1.452,2.299,3.48,2.299,5.538c0,2.059-0.837,4.086-2.299,5.538C144.75,154.133,142.723,154.969,140.664,154.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35D34F"
    },
    d: "M161.144,142.033c-2.058,0-4.086-0.836-5.538-2.299c-1.463-1.452-2.299-3.48-2.299-5.538 c0-2.058,0.836-4.086,2.299-5.538c1.452-1.463,3.48-2.299,5.538-2.299c2.058,0,4.086,0.836,5.538,2.299 c1.463,1.463,2.299,3.48,2.299,5.538c0,2.058-0.836,4.075-2.299,5.538C165.23,141.197,163.202,142.033,161.144,142.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M310.971,358.693c-2.068,0-4.085-0.837-5.538-2.299c-1.462-1.453-2.299-3.479-2.299-5.538 c0-2.06,0.837-4.086,2.299-5.539c1.453-1.462,3.469-2.298,5.538-2.298c2.06,0,4.086,0.836,5.539,2.298 c1.462,1.453,2.298,3.479,2.298,5.539c0,2.058-0.836,4.074-2.298,5.538C315.058,357.856,313.031,358.693,310.971,358.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M121.26,144.196c-2.058,0-4.075-0.847-5.538-2.299c-1.463-1.463-2.299-3.48-2.299-5.538 c0-2.069,0.836-4.086,2.299-5.549c1.462-1.452,3.48-2.287,5.538-2.287c2.069,0,4.086,0.836,5.548,2.287 c1.453,1.463,2.288,3.48,2.288,5.549c0,2.058-0.836,4.074-2.288,5.538C125.346,143.348,123.329,144.196,121.26,144.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009E2F"
    },
    d: "M406.904,313.417c-2.069,0-4.086-0.837-5.538-2.288c-1.463-1.463-2.299-3.479-2.299-5.548 c0-2.06,0.836-4.086,2.299-5.539c1.452-1.462,3.468-2.298,5.538-2.298c2.069,0,4.086,0.836,5.538,2.298 c1.463,1.463,2.299,3.479,2.299,5.539c0,2.068-0.836,4.085-2.299,5.548C410.99,312.58,408.963,313.417,406.904,313.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35D34F"
    },
    d: "M429.546,268.15c-2.913,0-5.711-1.631-7.062-4.431c-1.882-3.897-0.247-8.583,3.65-10.465 c5.911-2.853,9.583-8.708,9.583-15.278c0-4.329,3.508-7.837,7.837-7.837s7.837,3.508,7.837,7.837 c0,12.448-7.239,23.985-18.441,29.393C431.85,267.899,430.689,268.15,429.546,268.15z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorldMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/world-map.8409eb3c.svg";
export { ForwardRef as ReactComponent };